import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { FilterBarComponent } from "../filter-bar.component";
import { FilterBarItemPredicate, FilterBarItemSearchPredicate, FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./item-filter.component.scss";

@Component({
    selector: "item-filter",
    template: require("./item-filter.component.html")
})
export class ItemFilterComponent implements OnChanges, IFilterBarFilter {
    @Input() icon = "";
    @Input() defaultLabel = "Custom Filter";
    @Input() selected: any;
    @Input() name = "";
    @Input() type: FilterTriggerType = "custom";

    @Input() loading = false;
    @Input() items: any[];
    @Input() itemPromise: angular.IPromise<any>;
    @Input() itemDisplayProp: string;
    @Input() itemTemplate: TemplateRef<any>;

    @Input() filterPredicate: FilterBarItemPredicate<any>;
    @Input() searchPredicate: FilterBarItemSearchPredicate<any>;

    @Input() showAllItems = false;

    @Output() open = new EventEmitter();
    @Output() close = new EventEmitter();
    @Output() change = new EventEmitter();

    @ViewChild("itemFilterButton", { read: ElementRef }) itemFilterButtonRef: ElementRef<HTMLElement>;
    @ViewChild("defaultTemplate", { read: ViewContainerRef }) defaultTemplateContainer: ViewContainerRef;

    // ---

    filteredItemCount = 0;
    filteredItems: any[];
    displayItems: any[];
    searchText: string;

    showDropdown = false;
    visible?: boolean;

    constructor(protected readonly parent: FilterBarComponent, readonly elementRef: ElementRef<HTMLElement>
    ) {
        this.updateLabelText();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateLabelText();

        if (changes["itemPromise"] && this.itemPromise) {
            this.loading = !this.items;

            this.itemPromise.finally(() => {

                this.loading = false;
            });
        }

        if (changes["selected"] && this.selected) {
            this.visible = true;
            this.parent.updateFilterVisibility(this);
            this.parent.onFilterChange("custom", this.selected, { customName: this.defaultLabel, filterData: true });
        }

        if (changes["items"] && this.items || changes["loading"]) {
            this.processNewItems();
        }
    }

    ngAfterViewInit() {

        this.parent.registerFilter(this);
    }

    toggleDropdown() {
        this.showDropdown = !this.showDropdown;

        if (this.showDropdown) {
            this.open.emit();

            if (this.selected && this.filteredItems.indexOf(this.selected) < 0) {
                this.viewAllItems();
            }
        }
    }

    closeDropdown() {
        this.showDropdown = false;

        this.parent.childClosed(this);
        this.close.emit();
    }

    onItemClicked(item: any, hideDropDown = true) {
        this.selected = item;

        this.change.emit(item);
        this.parent.onFilterChange("custom", item, { customName: this.defaultLabel, filterData: true });

        this.updateLabelText();

        if (hideDropDown) {
            this.showDropdown = false;
        }
    }

    clearSelected() {
        this.onItemClicked(null);
    }

    onSearch(text: string) {
        this.searchText = text;
        this.searchItems();
    }

    viewAllItems() {

        this.filteredItemCount = 0;
        this.filteredItems = this.items;
        this.searchItems();
    }

    // ---

    private processNewItems() {
        this.prefilterDataset();
        this.alignSelectedItems();
        this.searchItems();
    }

    private prefilterDataset(): void {
        this.filteredItems = this.items;
        this.filteredItemCount = 0;

        if (!this.parent || !this.items?.length || this.showAllItems) {
            return;
        }

        this.filteredItems = this.parent.filterChildData(this, this.items);
        this.filteredItemCount = this.items.length - this.filteredItems.length;
    }

    private updateLabelText() {
        if (this.selected) {
            this.name = this.selected[this.itemDisplayProp] || this.selected;
        }
        else {
            this.name = this.defaultLabel;
        }
    }

    private searchItems() {
        if (!this.searchText) {
            this.displayItems = this.filteredItems;
            return;
        }

        this.displayItems = this.filteredItems.filter(i => {
            var result = this.searchPredicate(i, this.searchText);;
            return result;
        });
    }

    private alignSelectedItems() {
        // If we have changes, ensure our models now match
        if (this.selected && this.items) {
            var newSelected = this.items.find(i => i.Id == this.selected.Id);
            if (newSelected) {
                this.selected = newSelected;
            }
        }

        // If we cannot find out selected item in our filtered list, then show it in our main list
        if (this.selected && this.filteredItems.indexOf(this.selected) < 0) {
            this.viewAllItems();
        }
    }
}
